import React from 'react';
import { Box, Heading, Text, useColorModeValue } from '@chakra-ui/react';
import { BackgroundBeams } from "../ui/background-beams.tsx";
import { Helmet } from 'react-helmet';

const CookiesPolicy = () => {
  const textColor = useColorModeValue("gray.800", "gray.100");
  const headingColor = useColorModeValue("blue.700", "blue.300");
  const bgColor = useColorModeValue("white", "gray.800");

  return (
    <Box position="relative" bg={bgColor} minHeight="100vh" p={8}>
      <Helmet>
        <title>Cookies Policy | Gemini Cyber Security</title>
      </Helmet>

      <BackgroundBeams />

      <Box position="relative" zIndex={1}>
        <Heading size="lg" mb={4} color={headingColor}>
          Cookie Policy
        </Heading>
        <Text fontSize="md" color={textColor} maxW="800px">
          This page will contain our Cookie Policy. Content coming soon.
        </Text>
      </Box>
    </Box>
  );
};

export default CookiesPolicy;
